// =====================================
// ESTRUCTURA DE DATOS 100% ALINEADA CON SUPABASE
// =====================================

// 1. NEW ITEMS - Estructura estándar
export const NEW_ITEMS_DATA_STRUCTURE = {
  // Orden principal (tabla: orders)
  orderData: {
    user_id: "uuid",                    // ✅ orders.user_id
    order_status: "pending",            // ✅ orders.order_status
    payment_status: "pending",          // ✅ orders.payment_status
    subtotal: 0,                        // ✅ orders.subtotal
    shipping_cost: 0,                   // ✅ orders.shipping_cost
    total: 0,                          // ✅ orders.total
    notes: "string",                   // ✅ orders.notes
    created_by: "uuid"                 // ✅ orders.created_by
  },

  // Detalles de orden (tabla: order_details)
  orderDetails: [
    {
      order_id: "uuid",                 // ✅ order_details.order_id
      product_id: "uuid",              // ✅ order_details.product_id
      quantity: 1,                     // ✅ order_details.quantity
      unit_price: 0,                   // ✅ order_details.unit_price
      detail_type: "new",              // ✅ order_details.detail_type (ENUM)
      delivery_address_id: "uuid",     // ✅ order_details.delivery_address_id
      scheduled_delivery_date: "ISO",  // ✅ order_details.scheduled_delivery_date
      status: "recently_ordered",      // ✅ order_details.status (ENUM)
      created_by: "uuid"               // ✅ order_details.created_by
    }
  ],

  // Dirección (tabla: addresses)
  addressData: {
    user_id: "uuid",                   // ✅ addresses.user_id
    address: "string",                 // ✅ addresses.address
    city: "string",                    // ✅ addresses.city
    latitude: 0,                       // ✅ addresses.latitude
    longitude: 0,                      // ✅ addresses.longitude
    details: "string"                  // ✅ addresses.details
  }
};

// 2. NEW REFILLS - Estructura corregida
export const NEW_REFILLS_DATA_STRUCTURE = {
  // Items originales del frontend
  activeRefillItems: [
    {
      jugId: "uuid",                   // Mapea a: returned_jug_id
      barcode: "string",               // Para referencia
      addressId: "uuid",               // Mapea a: delivery_address_id
      address: "string",               // Para agrupación
      city: "string",                  // Para referencia
      price: 0,                        // Para cálculos
      quantity: 1,                     // Siempre 1 para refills
      latitude: 0,                     // Para referencia
      longitude: 0,                    // Para referencia
      user_id: "uuid"                  // Para validación
    }
  ],

  // Agrupación corregida por dirección
  groupedByAddress: {
    "address_key": {
      addressId: "uuid",              // ✅ delivery_address_id
      address: "string",              // Para display
      city: "string",                 // Para display
      items: [                        // Array de items para esta dirección
        {
          jugId: "uuid",              // ✅ returned_jug_id
          barcode: "string",
          price: 0,
          quantity: 1
        }
      ],
      subtotal: 0,                    // Calculado
      deliveryFee: 0,                 // Calculado por zona
      itemCount: 0                    // Calculado
    }
  },

  // Orden principal (tabla: orders)
  orderData: {
    user_id: "uuid",                  // ✅ orders.user_id
    order_status: "pending",          // ✅ orders.order_status
    payment_status: "pending",        // ✅ orders.payment_status
    subtotal: 0,                      // ✅ orders.subtotal
    shipping_cost: 0,                 // ✅ orders.shipping_cost (suma de deliveryFees)
    total: 0,                         // ✅ orders.total
    notes: "string",                  // ✅ orders.notes
    created_by: "uuid"                // ✅ orders.created_by
  },

  // Detalles de orden (tabla: order_details) - UNO POR BOTELLÓN
  orderDetails: [
    {
      order_id: "uuid",               // ✅ order_details.order_id
      product_id: "uuid",             // ✅ order_details.product_id (refill product)
      quantity: 1,                    // ✅ order_details.quantity (siempre 1)
      unit_price: 0,                  // ✅ order_details.unit_price (refill price)
      detail_type: "refill",          // ✅ order_details.detail_type (ENUM)
      returned_jug_id: "uuid",        // ✅ order_details.returned_jug_id
      delivery_address_id: "uuid",    // ✅ order_details.delivery_address_id
      scheduled_delivery_date: "ISO", // ✅ order_details.scheduled_delivery_date
      status: "recently_ordered",     // ✅ order_details.status (ENUM)
      created_by: "uuid"              // ✅ order_details.created_by
    }
  ]
};

// 3. FUNCIÓN PARA TRANSFORMAR DATOS DEL FRONTEND A SUPABASE
export const transformRefillDataForSupabase = (refillData, user, scheduledDate, timeSlot) => {
  const { activeRefillItems, totals } = refillData;

  // 1. Agrupar items por dirección correctamente
  const groupedByAddress = activeRefillItems.reduce((acc, item) => {
    const addressKey = `${item.addressId}`;
    
    if (!acc[addressKey]) {
      acc[addressKey] = {
        addressId: item.addressId,
        address: item.address,
        city: item.city,
        items: [],
        subtotal: 0,
        deliveryFee: 0, // Se calculará después
        itemCount: 0
      };
    }
    
    acc[addressKey].items.push({
      jugId: item.jugId,
      barcode: item.barcode,
      price: item.price,
      quantity: item.quantity || 1
    });
    
    acc[addressKey].subtotal += (item.price * (item.quantity || 1));
    acc[addressKey].itemCount += (item.quantity || 1);
    
    return acc;
  }, {});

  // 2. Calcular delivery fees por zona
  // TODO: Implementar lógica de zonas
  Object.values(groupedByAddress).forEach(group => {
    group.deliveryFee = 5000; // Placeholder - calcular por zona real
  });

  // 3. Estructurar datos para createBulkRefillOrder
  return {
    items: activeRefillItems, // Array plano original
    groupedByAddress: Object.values(groupedByAddress), // Array de objetos
    scheduledDate,
    timeSlot,
    totals: {
      subtotal: totals.totalPrice || 0,
      deliveryFee: Object.values(groupedByAddress).reduce((sum, group) => sum + group.deliveryFee, 0),
      total: (totals.totalPrice || 0) + Object.values(groupedByAddress).reduce((sum, group) => sum + group.deliveryFee, 0)
    }
  };
};

// 4. FUNCIÓN PARA VALIDAR DATOS ANTES DEL ENVÍO
export const validateOrderData = (orderData, type = 'refill') => {
  const errors = [];

  if (type === 'refill') {
    // Validar estructura de refills
    if (!orderData.items || !Array.isArray(orderData.items) || orderData.items.length === 0) {
      errors.push('Items de recambio requeridos');
    }

    if (!orderData.groupedByAddress || !Array.isArray(orderData.groupedByAddress)) {
      errors.push('Agrupación por dirección inválida');
    }

    if (!orderData.scheduledDate) {
      errors.push('Fecha de entrega requerida');
    }

    if (!orderData.totals || typeof orderData.totals.total !== 'number') {
      errors.push('Totales inválidos');
    }

    // Validar que cada item tenga los campos requeridos
    orderData.items?.forEach((item, index) => {
      if (!item.jugId) errors.push(`Item ${index}: jugId requerido`);
      if (!item.addressId) errors.push(`Item ${index}: addressId requerido`);
      if (typeof item.price !== 'number') errors.push(`Item ${index}: precio inválido`);
    });

    // Validar que cada grupo tenga los campos requeridos
    orderData.groupedByAddress?.forEach((group, index) => {
      if (!group.addressId) errors.push(`Grupo ${index}: addressId requerido`);
      if (!group.items || !Array.isArray(group.items)) errors.push(`Grupo ${index}: items requeridos`);
    });
  }

  return {
    isValid: errors.length === 0,
    errors
  };
};

// 5. ENUMS PARA MANTENER CONSISTENCIA
export const ORDER_STATUS = {
  PENDING: 'pending',
  CONFIRMED: 'confirmed',
  IN_PROGRESS: 'in_progress',
  DELIVERED: 'delivered',
  CANCELLED: 'cancelled'
};

export const PAYMENT_STATUS = {
  PENDING: 'pending',
  PARTIALLY_PAID: 'partially_paid',
  PAID: 'paid',
  REFUNDED: 'refunded'
};

export const DETAIL_TYPE = {
  NEW: 'new',
  REFILL: 'refill'
};

export const ORDER_DETAIL_STATUS = {
  RECENTLY_ORDERED: 'recently_ordered',
  CONFIRMED: 'confirmed',
  IN_TRANSIT: 'in_transit',
  DELIVERED: 'delivered',
  RETURNING: 'returning',
  EXPIRED: 'expired',
  OVERDUE_FOR_RETURN: 'overdue_for_return'
};
export const DELIVERY_STATUS = {
  PENDING: 'pending',
  READY_FOR_DELIVERY: 'ready_for_delivery',
  IN_TRANSIT: 'in_transit',
  DELIVERED: 'delivered'
};